import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AdminProvider } from "./contexts/AdminContext";
import ForSaleFloatingBadge from "./components/feature/ForSaleFloatingBadge";

function App() {
  return (
    <AdminProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <ForSaleFloatingBadge />
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </AdminProvider>
  );
}

export default App;